import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("single", (props) => {
  return (
    <div>
      <h1>{props.post?.title}</h1>
      <ContentBlocks blocks={props.post?.contentBlocks} />
    </div>
  )
})
